(function () {
  "use strict";

  // ——— money formatter ———
  // Read the format at CALL time, never at load time. theme.js can execute before
  // the inline script that assigns window.Shopify.money_format, and capturing it
  // in a const froze the "${{amount}}" fallback — which rendered 355 SEK as
  // "$355.00": the raw krona figure wearing a dollar sign.
  function currentMoneyFormat() {
    return (
      (window.Shopify && window.Shopify.money_format) ||
      "{{amount_no_decimals}} kr"
    );
  }
  function currentCurrency() {
    return (
      (window.Shopify &&
        window.Shopify.currency &&
        window.Shopify.currency.active) ||
      "SEK"
    );
  }
  function group(intStr, sep) {
    return intStr.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
  }
  // Renders one Shopify money token. Shopify has seven of them and this shop is
  // served in seven currencies (SEK, EUR, GBP, USD, CAD, AUD, NZD) — Markets
  // rewrites money_format per market, so handling only {{amount}} left EUR
  // customers looking at the literal string "€{{amount_with_comma_separator}}".
  function render(abs, neg, thousands, decimal, decimals) {
    const rounded = decimals ? abs : Math.round(abs / 100) * 100;
    const int = group(String(Math.floor(rounded / 100)), thousands);
    if (!decimals) return neg + int;
    return neg + int + decimal + String(rounded % 100).padStart(2, "0");
  }
  function formatMoney(cents) {
    const neg = cents < 0 ? "-" : "";
    const abs = Math.abs(Number(cents) || 0);
    // The SEK format this shop uses is "{{amount_no_decimals}} kr", whose
    // canonical separator is a comma — "1,065 kr" reads as 1.065 to a Swede.
    // snippets/sap-money.liquid prints a space for SEK; match it here so the
    // drawer and the product page can never disagree.
    const plain = currentCurrency() === "SEK" ? " " : ",";
    return currentMoneyFormat()
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, () =>
        render(abs, neg, ".", ",", false),
      )
      .replace(/\{\{\s*amount_no_decimals_with_space_separator\s*\}\}/g, () =>
        render(abs, neg, " ", ",", false),
      )
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, () =>
        render(abs, neg, ".", ",", true),
      )
      .replace(/\{\{\s*amount_with_space_separator\s*\}\}/g, () =>
        render(abs, neg, " ", ",", true),
      )
      .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/g, () =>
        render(abs, neg, "'", ".", true),
      )
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, () =>
        render(abs, neg, plain, ".", false),
      )
      .replace(/\{\{\s*amount\s*\}\}/g, () =>
        render(abs, neg, plain, plain === " " ? "," : ".", true),
      );
  }
  window.formatMoney = formatMoney;

  // ——— cart drawer ———
  const drawer = document.querySelector("[data-cart-drawer]");
  const overlay = document.querySelector("[data-cart-overlay]");

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add("open");
    overlay && overlay.classList.add("open");
    document.documentElement.style.overflow = "hidden";
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove("open");
    overlay && overlay.classList.remove("open");
    document.documentElement.style.overflow = "";
  }
  document.addEventListener("click", function (e) {
    const open = e.target.closest("[data-cart-open]");
    const close = e.target.closest("[data-cart-close]");
    if (open) {
      e.preventDefault();
      openDrawer();
      refreshCart();
    }
    if (close) {
      e.preventDefault();
      closeDrawer();
    }
  });

  // ——— refresh cart contents ———
  async function fetchCart() {
    const res = await fetch("/cart.js", {
      headers: { Accept: "application/json" },
    });
    return res.json();
  }
  function renderCart(cart) {
    const body = drawer && drawer.querySelector("[data-cart-body]");
    const footer = drawer && drawer.querySelector("[data-cart-footer]");
    const countEls = document.querySelectorAll("[data-cart-count]");
    countEls.forEach((el) => {
      el.textContent = cart.item_count;
    });

    if (!body) return;

    if (cart.item_count === 0) {
      body.innerHTML =
        '<div class="drawer-empty"><h4 class="serif">' +
        (window.SerenStrings.empty || "Nothing here yet.") +
        "</h4><p>" +
        (window.SerenStrings.empty_sub || "") +
        "</p>" +
        '<button class="btn btn-ink" style="margin-top:24px" data-cart-close onclick="window.location.href=\'/collections/all\'">' +
        (window.SerenStrings.start_shopping || "Start shopping") +
        "</button></div>";
      footer && (footer.style.display = "none");
      return;
    }
    footer && (footer.style.display = "");

    const items = cart.items
      .map(function (item) {
        const props = item.properties || {};
        const subBadge = item.selling_plan_allocation
          ? "Subscribe · " +
            (item.selling_plan_allocation.selling_plan.name || "")
          : "One-time";
        const img =
          item.featured_image && item.featured_image.url
            ? '<img src="' +
              item.featured_image.url +
              '" alt="' +
              (item.title || "") +
              '" />'
            : '<div class="ph"></div>';
        return (
          '<div class="cart-item" data-line-key="' +
          item.key +
          '">' +
          '<div class="cart-item-img">' +
          img +
          "</div>" +
          '<div class="cart-item-body">' +
          "<h5>" +
          item.product_title +
          "</h5>" +
          '<div class="meta">' +
          (item.variant_title && item.variant_title !== "Default Title"
            ? item.variant_title + " · "
            : "") +
          subBadge +
          "</div>" +
          '<div class="cart-item-qty">' +
          "<button data-line-decrement>−</button>" +
          "<span>" +
          item.quantity +
          "</span>" +
          "<button data-line-increment>+</button>" +
          "</div>" +
          "</div>" +
          "<div>" +
          '<div class="cart-item-price">' +
          formatMoney(item.final_line_price) +
          "</div>" +
          '<span class="cart-item-remove" data-line-remove>Remove</span>' +
          "</div>" +
          "</div>"
        );
      })
      .join("");

    // Free shipping is a QUANTITY rule, delivered by the automatic discount
    // "Free shipping on 3+ pouches" — not a subtotal rule. This re-render used to
    // count up to settings.free_shipping_threshold (890 kr) and so contradicted
    // the server-rendered drawer. Must match free_ship_qty in
    // snippets/cart-drawer.liquid and snippets/sap-supply.liquid.
    const FREE_SHIP_QTY = 3;
    const toFreeQty = Math.max(0, FREE_SHIP_QTY - cart.item_count);
    const progress = Math.min(100, (cart.item_count / FREE_SHIP_QTY) * 100);

    const upsell =
      '<div class="drawer-upsell">' +
      '<div class="drawer-upsell-bar"><div style="width:' +
      progress +
      '%"></div></div>' +
      '<span class="mono">' +
      (toFreeQty > 0
        ? toFreeQty === 1
          ? "Add 1 more pouch for free shipping"
          : "Add " + toFreeQty + " pouches for free shipping"
        : "✓ Free shipping!") +
      "</span>" +
      "</div>";

    const subtotalRow =
      '<div class="drawer-row"><span>Subtotal</span><span>' +
      formatMoney(cart.items_subtotal_price) +
      "</span></div>" +
      '<div class="drawer-row"><span>Shipping</span><span>' +
      (toFreeQty > 0 ? "Calculated at checkout" : "Free") +
      "</span></div>" +
      '<div class="drawer-row total"><span>Total</span><span>' +
      formatMoney(cart.total_price) +
      "</span></div>" +
      '<form action="/cart" method="post"><button type="submit" name="checkout" class="btn btn-moss btn-block btn-lg">Checkout →</button></form>';

    body.innerHTML = items;
    if (footer) footer.innerHTML = upsell + subtotalRow;
  }
  async function refreshCart() {
    const cart = await fetchCart();
    renderCart(cart);
  }
  window.refreshCart = refreshCart;

  // ——— add to cart (forms with data-add-form) ———
  document.addEventListener("submit", async function (e) {
    const form = e.target.closest("[data-add-form]");
    if (!form) return;
    e.preventDefault();
    const formData = new FormData(form);
    const btn = form.querySelector("[type=submit]");
    const originalText = btn ? btn.textContent : "";
    if (btn) {
      btn.disabled = true;
      btn.textContent = "Adding…";
    }
    try {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: formData,
      });
      if (!res.ok) throw new Error(await res.text());
      await refreshCart();
      openDrawer();
    } catch (err) {
      console.error(err);
      alert("Couldn't add to cart. " + (err.message || ""));
    } finally {
      if (btn) {
        btn.disabled = false;
        btn.textContent = originalText;
      }
    }
  });

  // ——— line item updates inside drawer ———
  document.addEventListener("click", async function (e) {
    const lineEl = e.target.closest("[data-line-key]");
    if (!lineEl) return;
    const key = lineEl.getAttribute("data-line-key");
    const qtyEl = lineEl.querySelector(".cart-item-qty span");
    const currentQty = parseInt(qtyEl ? qtyEl.textContent : "1", 10);

    let newQty = null;
    if (e.target.matches("[data-line-decrement]"))
      newQty = Math.max(0, currentQty - 1);
    if (e.target.matches("[data-line-increment]")) newQty = currentQty + 1;
    if (e.target.matches("[data-line-remove]")) newQty = 0;
    if (newQty === null) return;
    e.preventDefault();
    await fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ id: key, quantity: newQty }),
    });
    await refreshCart();
  });

  // ——— accordions (data-accordion + data-accordion-item) ———
  document.addEventListener("click", function (e) {
    const trigger = e.target.closest("[data-accordion-trigger]");
    if (!trigger) return;
    const item = trigger.closest("[data-accordion-item]");
    if (!item) return;
    const group = item.closest("[data-accordion]");
    const isOpen = item.classList.contains("open");
    if (group && group.hasAttribute("data-accordion-single")) {
      group
        .querySelectorAll("[data-accordion-item].open")
        .forEach((it) => it.classList.remove("open"));
    }
    if (isOpen) item.classList.remove("open");
    else item.classList.add("open");
  });

  // ——— PDP gallery thumbs ———
  document.addEventListener("click", function (e) {
    const thumb = e.target.closest("[data-thumb]");
    if (!thumb) return;
    const idx = thumb.getAttribute("data-thumb");
    const gallery = thumb.closest("[data-gallery]");
    if (!gallery) return;
    gallery
      .querySelectorAll("[data-thumb]")
      .forEach((t) => t.classList.remove("active"));
    thumb.classList.add("active");
    gallery.querySelectorAll("[data-main-image]").forEach((img) => {
      img.classList.toggle(
        "is-hidden",
        img.getAttribute("data-main-image") !== idx,
      );
    });
  });

  // ——— PDP take-for hover ———
  document.addEventListener("mouseover", function (e) {
    const item = e.target.closest("[data-take-item]");
    if (!item) return;
    const list = item.closest("[data-take-list]");
    if (!list) return;
    list
      .querySelectorAll("[data-take-item]")
      .forEach((it) => it.classList.remove("active"));
    item.classList.add("active");
    const idx = item.getAttribute("data-take-item");
    const root = list.closest("[data-take-root]");
    if (root) {
      root.querySelectorAll("[data-take-image]").forEach((img) => {
        img.classList.toggle(
          "is-hidden",
          img.getAttribute("data-take-image") !== idx,
        );
      });
    }
  });

  // ——— PDP purchase + qty + selling plan ———
  document.addEventListener("click", function (e) {
    const opt = e.target.closest("[data-purchase-option]");
    if (opt) {
      const block = opt.closest("[data-purchase-block]");
      if (!block) return;
      block
        .querySelectorAll("[data-purchase-option]")
        .forEach((o) => o.classList.remove("active", "recommended"));
      opt.classList.add("active");
      if (opt.getAttribute("data-purchase-option") === "subscribe")
        opt.classList.add("recommended");
      const planInput = block.querySelector("[name='selling_plan']");
      const sellingPlan = opt.getAttribute("data-selling-plan");
      if (planInput) planInput.value = sellingPlan || "";
      // toggle prices visible
      block.querySelectorAll("[data-price-for]").forEach((p) => {
        p.classList.toggle(
          "is-hidden",
          p.getAttribute("data-price-for") !==
            opt.getAttribute("data-purchase-option"),
        );
      });
    }
    const qBtn = e.target.closest("[data-qty-wrap] [data-qty]");
    if (qBtn) {
      const wrap = qBtn.closest("[data-qty-wrap]");
      const form = qBtn.closest("form");
      const input =
        (wrap && wrap.querySelector("input[name='quantity']")) ||
        (form && form.querySelector("input[name='quantity']"));
      const display = wrap && wrap.querySelector("[data-qty-display]");
      if (!input) return;
      const cur = parseInt(input.value || "1", 10);
      const next =
        qBtn.getAttribute("data-qty") === "+" ? cur + 1 : Math.max(1, cur - 1);
      input.value = next;
      if (display) display.textContent = next;
    }
  });

  // ——— FAQ tag filter (reviews page) ———
  document.addEventListener("click", function (e) {
    const tag = e.target.closest("[data-filter]");
    if (!tag) return;
    const wrap = tag.closest("[data-filter-wrap]");
    if (!wrap) return;
    const value = tag.getAttribute("data-filter");
    wrap
      .querySelectorAll("[data-filter]")
      .forEach((t) => t.classList.toggle("is-active", t === tag));
    const grid = document.querySelector("[data-review-grid]");
    if (!grid) return;
    grid.querySelectorAll("[data-review-tag]").forEach((card) => {
      const tags = (card.getAttribute("data-review-tag") || "").toLowerCase();
      card.classList.toggle(
        "is-hidden",
        value !== "all" && !tags.includes(value),
      );
    });
  });

  // ——— bundle builder ———
  // The builder lives entirely in sections/seren-apple-bundle.liquid, which
  // ships its own script bound to data-sap-bundle-* attributes. The copy that
  // used to sit here bound to data-bundle-* — which appears on no page — so it
  // was dead code carrying a SECOND, contradictory set of discount rules.
  // One source of truth: edit the section.
})();
